<div *ngIf="lx('HelpUrl')" class="topbar-item px-5">
    <a [class]="textCssClass" [href]="l('HelpUrl') | safe: 'url'" target="_blank">{{l('HelpHeaderText')}}</a>
</div>
